import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ActivationPreService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation pre
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getActivationPre(configData: any) {
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);

                this.httpService.get(UrlConnectionEnum.GET_ACTIVATION_PRE, configData, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });

            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Sends activation pre
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async sendActivationPre(configData: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.SEND_ACTIVATION_PRE, configData, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }
}
